import React from 'react';
import { View, Text } from '@react-pdf/renderer';
import { DISCONTINUED } from '@mummssoftware/utils/constants';
import { formatDateMMDDYY, YYYYMMDDtoMMDDYY } from '@mummssoftware/utils/formatters';
import { isTaskSelected } from '@mummssoftware/utils/form-engine/form-engine-utils';
import { styles } from '../../../utils';
import { getCreatePersonCredential, getModUserCredential } from '../utils/utils';
import defaults from '../../../translations/en.json';

var _ref = /*#__PURE__*/React.createElement(View, null);

var _ref2 = /*#__PURE__*/React.createElement(View, null);

export const CPPTasksPDF = ({
  allCppTasks
}) => {
  const selectedTasks = allCppTasks && allCppTasks.map(taskAsId => {
    if (isTaskSelected(Object.values(taskAsId)[0])) {
      return Object.values(taskAsId)[0];
    }

    return undefined;
  }).filter(e => e !== undefined);
  return /*#__PURE__*/React.createElement(View, {
    style: [styles.width100, styles.paddingLeftPointFiveCm]
  }, /*#__PURE__*/React.createElement(Text, {
    style: [styles.CPFTableDetailsText, styles.fontWeightBold, styles.width250]
  }, `${defaults.patientTasks}`), selectedTasks && selectedTasks.length ? selectedTasks.map(task => {
    const isDC = task.status === DISCONTINUED;
    return /*#__PURE__*/React.createElement(View, {
      style: styles.rowTask,
      key: task.id
    }, /*#__PURE__*/React.createElement(Text, {
      style: [styles.CPFTableDetailsText, styles.width190]
    }, `• ${task.who} ${task.tasktext} ${task.frequency} ${defaults.timesPer} ${task.period}`), /*#__PURE__*/React.createElement(Text, {
      style: [styles.CPFTableDetailsText]
    }, `${YYYYMMDDtoMMDDYY(task.effectivedate)} ${getCreatePersonCredential(task)}`), isDC ? /*#__PURE__*/React.createElement(Text, {
      style: [styles.CPFTableDetailsText, styles.paddingLeftPointFiveCm]
    }, `${formatDateMMDDYY(task.statusdatetime)} ${getModUserCredential(task)}`) : _ref);
  }) : _ref2);
};